export default [
    {
      path: '/admin/product-labels',
      name: 'product-label',
      meta: { requiresAuth: true },
      component: () => import('@/pages/product/label')
    },
    {
      path: '/admin/product-labels-by-imeis',
      name: 'product-label-by-imei',
      meta: { requiresAuth: true },
      component: () => import('@/pages/product/label/by-imei.vue')
    }
  ]